import { gql } from "@apollo/client";

export const GET_SUGGESTED_PROMPTS = gql`
  query GetSuggestedPrompts($category: String!) {
    suggestedPrompts(category: $category) {
      id
      text
      category
      isAccessible
      tierUpgradeHint
    }
  }
`;

export const GET_MY_CONVERSATIONS = gql`
  query GetMyConversations($first: Int, $offset: Int) {
    myConversations(first: $first, offset: $offset) {
      id
      title
      startedAt
      messageCount
      firstMessagePreview
      isActive
      isAccessible
      daysOld
    }
  }
`;

export const GET_CONVERSATION = gql`
  query GetConversation($id: String!) {
    conversation(id: $id) {
      isAccessible
      focusedClassId
      focusedAssignmentId
      latestRequest {
        requestId
        requestStatus
        error
        originalCreation
        originalMessage
        originalConversationId
      }
      id
      title
      startedAt
      messageCount
      messages {
        id
        message
        isResponse
        sentAt
        dslQuery
      }
    }
  }
`;

export const GET_ASSISTANT_USAGE_STATS = gql`
  query GetAssistantUsageStats {
    assistantUsageStats {
      responseCount
      responseLimit
      limitReached
      tier
      canCreateNewConversation
    }
  }
`;

export const GET_ASSISTANT_REQUEST = gql`
  query GetAssistantRequest($requestId: UUID!) {
    assistantRequest(requestId: $requestId) {
      requestId
      requestStatus
      conversationId
      message
      error
      errorCode
      responseCount
      responseLimit
      limitReached
    }
  }
`;

export const GET_ASSISTANT_ACTIONS = gql`
  query AssistantActions($conversationId: String!) {
    assistantActions(conversationId: $conversationId)
  }
`;

export const GET_ASSISTANT_CREATION_OPTIONS = gql`
  query AssistantCreationOptions($classId: ID!) {
    assistantCreationOptions(classId: $classId)
  }
`;
